import React, { useContext, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Typography
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { UserContext } from 'src/contexts/userContext';
import { UserType } from 'src/interfaces/UserTypes';
import FileUploadButton from 'src/components/FileUploadButton';
import DocumentList from 'src/components/DocumentList';

interface DocumentsTabProps {
  installationId: number;
}

function DocumentsTab({ installationId }: DocumentsTabProps) {
  const { currentUser } = useContext(UserContext);
  const [refreshKey, setRefreshKey] = useState(0);
  const canDelete = currentUser?.userType === UserType.admin;

  return (
    <Container maxWidth="lg" sx={{ mt: 3, mb: 3 }}>
      <Card>
        <CardHeader
          title={
            <FormattedMessage
              id="installationDocuments"
              defaultMessage="Installation Documents"
            />
          }
        />
        <Divider />
        <CardContent>
          <DocumentList
            installationId={installationId}
            refreshKey={refreshKey}
            canDelete={canDelete}
          />
          <Box sx={{ mt: 2 }}>
            <FileUploadButton
              scope={1}
              installationId={installationId}
              onUploaded={() => setRefreshKey((k) => k + 1)}
            />
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
            <FormattedMessage
              id="documentsHint"
              defaultMessage="Accepted formats: JPEG, PNG, GIF, WebP, PDF. Maximum file size: 25 MB."
            />
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
}

export default DocumentsTab;
